import CardCertificate from './CardCertificate';

export default CardCertificate;
